import { Auth, Auth0Provider } from '@sloyd/auth';
import { actions, selectors, useDispatch, useSelector } from '@sloyd/store-base';
import { useMemo } from 'react';
import { useMount } from 'react-use';
import { $ac, invokeEvent } from 'shared-base';
import { App } from './App';

export const AppContainer = () => {
  const dispatch = useDispatch();
  const appState = useSelector(selectors.raw.$rawAppState);
  const { showLogs, isSlimVersion, navbarWidthLeft } = appState;

  useMount(() => {
    dispatch($ac('BOOTSTRAP'));
  });

  const callbacks = useMemo(
    () => ({
      onLogoClick: () => {
        invokeEvent('nav', { path: '/generators' });
      },
      onNavigate: (path: string) => {
        invokeEvent('nav', { path });
      },
      onAction: (action: Action) => {
        dispatch(action);
      },
      toggleLogs: () => {
        dispatch(actions.appState.patch({ showLogs: !showLogs }));
      },
    }),
    [showLogs]
  );

  return (
    <Auth0Provider
      domain={import.meta.env.VITE_AUTH0_DOMAIN}
      clientId={import.meta.env.VITE_AUTH0_CLIENTID}
      authorizationParams={{
        redirect_uri: window.location.origin,
        audience: import.meta.env.VITE_AUTH0_AUDIENCE,
      }}
    >
      <Auth />
      <App navbarWidth={navbarWidthLeft} callbacks={callbacks} />
    </Auth0Provider>
  );
};
